import { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";
import { useDictation } from "@/hooks/use-dictation";
import { Loader2, Mic, Square } from "lucide-react";
import "./field.css";

/**
 * DictateButton – liten mikrofon ved et tekstfelt: dikter rett inn i feltet (legges til det som står der fra før).
 * Rendres ikke der nettleseren mangler støtte – feltet fungerer som før.
 */
export function DictateButton({ value, onChange, className, testId = "dictate-button", label = "Dikter" }) {
  const d = useDictation({ lang: "nb-NO" });
  const pushed = useRef(null);
  useEffect(() => {
    if (d.listening || d.text !== pushed.current) {
      if (d.text !== pushed.current && pushed.current !== null) { pushed.current = d.text; onChange(d.text); }
    }
  }, [d.text, d.listening, onChange]);
  if (!d.supported) return null;
  const start = () => { d.setText(value || ""); pushed.current = value || ""; d.start(); };
  return (
    <button type="button" className={cn("voice-mic voice-mic-sm", className)} data-listening={d.listening ? "true" : "false"} onClick={d.listening || d.starting ? d.stop : start} aria-pressed={d.listening} aria-label={d.listening ? "Stopp diktering" : label} title={d.error?.message || (d.listening ? "Stopp" : label)} data-testid={testId}>
      <span className="voice-mic-ring" /><span className="voice-mic-ring" />
      {d.starting ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : d.listening ? <Square className="h-3.5 w-3.5 fill-current" /> : <Mic className="h-4 w-4" />}
    </button>
  );
}
